import { render, staticRenderFns } from "./BranchPostIndexMailsModalComponent.vue?vue&type=template&id=590ef3c6&scoped=true"
import script from "./BranchPostIndexMailsModalComponent.vue?vue&type=script&lang=js"
export * from "./BranchPostIndexMailsModalComponent.vue?vue&type=script&lang=js"
import style0 from "./BranchPostIndexMailsModalComponent.vue?vue&type=style&index=0&id=590ef3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ef3c6",
  null
  
)

export default component.exports